/* eslint-disable no-unused-vars */
import Dashboard from './pages/dashboard/Dashboard';
import Orders from './pages/orders/Orders';
// eslint-disable-next-line import/no-cycle
import ProductForm from './pages/products/ProductForm';
import Products from './pages/products/Products';
import Payments from './pages/settings/payments/Payments';
import Ram from './pages/settings/ram/Ram';
// eslint-disable-next-line import/no-cycle
import Settings from './pages/settings/Settings';
import EditProfile from './pages/profile/EditProfile';
import ShipStation from './pages/settings/shipStation/ShipStation';
import SocialProfile from './pages/settings/socialProfile/SocialProfile';
import Store from './pages/settings/store/Store';
import Verification from './pages/settings/verification/Verification';
import Withdraw from './pages/withdraw/withdraws';
import OrderDetails from './pages/orders/OrderDetailsPage/OrderDetails';

const Routes = [
    {
        id: 1,
        name: 'Dashboard',
        path: '/',
        component: Dashboard,
        icon: '#dashboard',
        sidebar: true,
    },
    {
        id: 2,
        name: 'Products',
        path: '/products',
        component: Products,
        icon: '#products',
        sidebar: true,
    },
    {
        id: 3,
        name: 'Orders',
        path: '/orders',
        component: Orders,
        icon: '#orders',
        sidebar: true,
    },

    {
        id: 4,
        name: 'Product Create',
        path: '/products/create',
        component: ProductForm,
        icon: '#coupons',
        sidebar: false,
    },
    {
        id: 5,
        name: 'Order Details',
        path: '/orders/:orderId',
        component: OrderDetails,
        icon: '#coupons',
        sidebar: false,
    },
    {
        id: 6,
        name: 'Product Update',
        path: '/products/update/:productId',
        component: ProductForm,
        icon: '#coupons',
        sidebar: false,
    },

    {
        id: 7,
        name: 'Withdraw',
        path: '/withdraw',
        component: Withdraw,
        icon: '#withdraw',
        sidebar: true,
    },
    {
        id: 8,
        name: 'EditProfile',
        path: '/edit-account',
        component: EditProfile,
        icon: '#withdraw',
        sidebar: false,
    },
    {
        id: 20,
        name: 'Settings',
        path: '/settings',
        component: Settings,
        icon: '#settings',
        sidebar: true,
        subMenu: [
            {
                id: 1,
                name: 'Store',
                path: '/store',
                component: Store,
                icon: '#store',
            },

            {
                id: 2,
                name: 'Payment',
                path: '/payment',
                component: Payments,
                icon: '#payment',
            },
            // {
            //     id: 4,
            //     name: 'Verification',
            //     path: '/verification',
            //     component: Verification,
            //     icon: '#verification',
            // },
            // {
            //     id: 5,
            //     name: 'Ship Station',
            //     path: '/ship-station',
            //     component: ShipStation,
            //     icon: '#ship-station',
            // },
            // {
            //     id: 6,
            //     name: 'Social Profile',
            //     path: '/social',
            //     component: SocialProfile,
            //     icon: '#social-profile',
            // },
            // {
            //     id: 7,
            //     name: 'RAM',
            //     path: '/ram',
            //     component: Ram,
            //     icon: '#ram',
            // },
        ],
    },
];

export default Routes;
